import { render } from "./ActivitiesTab.vue?vue&type=template&id=2d928bd5&scoped=true"
import script from "./ActivitiesTab.vue?vue&type=script&lang=js"
export * from "./ActivitiesTab.vue?vue&type=script&lang=js"

import "./ActivitiesTab.vue?vue&type=style&index=0&id=2d928bd5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d928bd5"]])

export default __exports__